import { DOCUMENT } from '@angular/common';
import { Component, ElementRef, Inject, Input, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import _ from 'lodash';
import { map, Observable, of } from 'rxjs';
import { AppCustomBreadcrumbService } from './custom-breadcrumb.service';
import { AppAuthDataService } from '../../../../services/authData.service';
import { AppLocaleService } from '../../../../services/locale.service';
import { AppSharedImportsModule } from '../../../@shared/shared.imports.module';

interface Breadcrumb {
  label: {
    description?: string;
    iconName: string;
    title: string;
  };
  url: string;
}

export function Replace(el: any): any {
  const nativeElement: HTMLElement = el.nativeElement;
  const parentElement: HTMLElement | null = nativeElement.parentElement;
  if (!parentElement) {
    return;
  }
  // move all children out of the element
  while (nativeElement.firstChild) {
    parentElement.insertBefore(nativeElement.firstChild, nativeElement);
  }
  // remove the empty element(the host)
  parentElement.removeChild(nativeElement);
}

@Component({
  selector: 'app-custom-breadcrumb',
  standalone: true,
  imports: [
    AppSharedImportsModule
  ],
  template: `
    <ng-template ngFor let-breadcrumb [ngForOf]="breadcrumbs | async" let-last = last>
      <li class="breadcrumb-item"
          *ngIf="(breadcrumb.label?.title ?? '')"
          [ngClass]="{active: last}">
        <span [innerHTML]="breadcrumb.label.title | safeHtml"></span>
      </li>
      <span *ngIf="last && showMenuDescription" class="position-absolute text-primary" style="font-weight: 600; right: 1rem;">
        <span title="{{breadcrumb.label.title}}"><i class="{{breadcrumb.label.iconName}}"></i>&nbsp;{{breadcrumb.label.description}}</span>
      </span>
    </ng-template>
  `
})
export class AppCustomBreadcrumbComponent implements OnInit, OnDestroy {
  @Input() fixed = false;
  public breadcrumbs!: Observable<Breadcrumb[]>;
  private readonly fixedClass = 'breadcrumb-fixed';

  constructor(
    @Inject(DOCUMENT) private document: any,
    private renderer: Renderer2,
    public service: AppCustomBreadcrumbService,
    public el: ElementRef,
    private authDataService: AppAuthDataService,
    private localeService: AppLocaleService,

  ) { }

  public getTitle(breadcrumb: Breadcrumb): string {
    if (!breadcrumb?.label?.title) {
      return ""
    }

    return this.localeService.getMenuTranslate(breadcrumb.label.title) ?? this.localeService.translate.instant(breadcrumb.label.title);
  }

  public ngOnInit(): void {
    this.menus_flatten = this.authDataService.authDataGet().menus_flatten;

    Replace(this.el);
    this.isFixed(this.fixed);
    let breadcrumbarray: Breadcrumb[] = [];

    let doIt = () => {
      this.breadcrumbs = of(breadcrumbarray).pipe(
        map((breadcrumbs: any[]) => {
          return breadcrumbs.map((x: any) => {
            let menu = this.getMenu(x.url);
            var title = (this.useMenuTitle ? (menu?.Title) : x.label?.title) ?? x.label?.title;
            return {
              label: {
                description: menu?.Description ?? "",
                iconName: menu?.IconName ?? "",
                title: this.localeService.getMenuTranslate(title) as string
              },
              url: x.url
            };
          });
        })
      );
    }

    this.service.breadcrumbs.subscribe((breadcrumbs: Breadcrumb[]) => {
      breadcrumbarray = breadcrumbs.map((x: any) => ({
        label: {
          description: "",
          iconName: "",
          title: x.label
        },
        url: x.url
      }));
      doIt();
    });
    doIt();
  }

  ngOnDestroy(): void {
    this.renderer.removeClass(this.document.body, this.fixedClass);
  }

  // Visualizzazione della descrizione del menù
  @Input() showMenuDescription = true;
  // Utilizza o meno il titolo definito per la voce di menù
  @Input() useMenuTitle = true;

  private menus_flatten: Array<IUserMenuDTO> = [];

  public isFixed(fixed: boolean = this.fixed): void {
    if (fixed) {
      this.renderer.addClass(this.document.body, this.fixedClass);
    }
  }

  private getMenu(url: string): IUserMenuDTO | undefined {
    return this.menus_flatten.find(x => x.ItemUrl === url.replace(/\/\//g, "\/"));
  }
}
